module.exports = __webpack_public_path__ + "static/img/2.8f165e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/2.png
// module id = W7Eo
// module chunks = 0